var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'dokbot-component mx-auto',
    { 'dokbot-component--in-phone-preview': _vm.inPhonePreview },
    { 'dokbot-component--in-modal-preview mx-auto': _vm.inModalPreview }
  ],attrs:{"id":"dokbot"}})
}
var staticRenderFns = []

export { render, staticRenderFns }